// Mirrors src/Domain/Enums/HbelSubstanceType.cs — serialized as integers (enum value).
// The database column stores the name as text (HasConversion<string>), but that is persistence
// only; the API sends the ordinal like every other enum in the app.
//
// null/undefined is a real, meaningful state: an unclassified entry is selectable from BOTH the
// product API picker and the cleaning agent picker. Note that API is 0 — falsy — so every check
// against these values must test `!= null`, never truthiness, or an API reads as unclassified.
export const HBEL_SUBSTANCE_TYPE = Object.freeze({
  API: 0,
  CLEANING_AGENT: 1,
});

export const HBEL_SUBSTANCE_TYPE_LABELS = Object.freeze({
  [HBEL_SUBSTANCE_TYPE.API]: 'API',
  [HBEL_SUBSTANCE_TYPE.CLEANING_AGENT]: 'Cleaning Agent/Disinfectant',
});

// Shown where a blank value needs a word rather than an em dash — it means "usable anywhere",
// not "missing".
export const HBEL_SUBSTANCE_TYPE_ANY_LABEL = 'Any';

export const HBEL_SUBSTANCE_TYPE_OPTIONS = Object.freeze([
  HBEL_SUBSTANCE_TYPE.API,
  HBEL_SUBSTANCE_TYPE.CLEANING_AGENT,
]);

/** True when a registry entry may be selected for the given consumer. */
export function isSelectableAs(hbel, substanceType) {
  return hbel?.substanceType == null || hbel.substanceType === substanceType;
}
